
import {
  Box,
  Card,
  CardContent,
  IconButton,
  TextField,
  Tooltip,
  Divider,
  Stack,
  Select,
  MenuItem,
  useTheme,
  Typography,
} from "@mui/material";
import { ContentCopy, Delete, DragIndicator } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { QuestionnaireItemFreeTextSize } from "../../_helpers";
import QuestionnaireFormActionToolbar from "./QuestionnaireFormActionToolbar";

const QuestionnaireFormFreeTextTitle = ({
  data,
  sectionIndex,
  questionIndex,
  updateQuestion,
  deleteQuestion,
  duplicateQuestion,
  activeToolbarKey,
  handleAddQuestion,
  handleAddSection,
  handleAddFreeText,
  error
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleFontSizeChange = (e) => {
    const newFontSize = e.target.value;
    updateQuestion(sectionIndex, questionIndex, { freeTextSize: newFontSize });
  };

  const freeTextFontSize = [
    { label: t("questionnaire.form.freeTextFontSize.0"), value: QuestionnaireItemFreeTextSize.Small },
    { label: t("questionnaire.form.freeTextFontSize.1"), value: QuestionnaireItemFreeTextSize.Medium },
    { label: t("questionnaire.form.freeTextFontSize.2"), value: QuestionnaireItemFreeTextSize.Large },
  ];

  return (
    <Box sx={{ position: "relative" }}>
      <Card
        sx={{
          borderRadius: 1.5,
          mb: 3,
          overflow: "visible",
          border: error
            ? `1px solid ${theme.palette.error.main}`
            : "1px solid transparent",
        }}
      >
        <CardContent>
          <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
            <DragIndicator sx={{ cursor: "grab" }} />
            <TextField
              fullWidth
              variant="standard"
              placeholder={t('questionnaire.form.freeTextTitle')}
              value={data.text}
              multiline
              onChange={(e) =>
               updateQuestion(sectionIndex, questionIndex, { text: e.target.value })
              }          
            />

            <Select
              size="small"
              value={data.freeTextSize ?? QuestionnaireItemFreeTextSize.Medium}
              onChange={handleFontSizeChange}
              sx={{ minWidth: 150 }}
            >
              {freeTextFontSize.map((f) => (
                <MenuItem key={f.value} value={f.value}>
                  {f.label}
                </MenuItem>
              ))}
            </Select>
          </Stack>
          <Divider sx={{ mt: 2 }} />
          <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
            <Tooltip title={t('general.copy')}>
              <IconButton onClick={duplicateQuestion}>
                <ContentCopy fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('general.copy')}>
              <IconButton onClick={deleteQuestion}>
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </CardContent>
        {error &&
          <Typography color="error" variant="body2" sx={{ m: 1 }}>{error}</Typography>
        }
      </Card>

      {`${sectionIndex}-${questionIndex}` == activeToolbarKey && (
        <QuestionnaireFormActionToolbar
          onAddQuestion={handleAddQuestion}
          onAddSection={handleAddSection}
          onAddFreeText={handleAddFreeText}
        />
      )}
    </Box>
  );
};

export default QuestionnaireFormFreeTextTitle;
